var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisapprove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-4 w-4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f44336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.283 19.717c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l13.434-13.434c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-13.434 13.434c-.196.196-.451.293-.707.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.717 19.717c-.256 0-.512-.098-.707-.293l-13.434-13.434c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l13.434 13.434c.391.391.391 1.023 0 1.414-.195.196-.451.293-.707.293z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisapprove);
export default __webpack_public_path__ + "static/media/disapprove.7f59e4443a83b176d9e588bdfd156977.svg";
export { ForwardRef as ReactComponent };